import styled, { css } from 'styled-components';

export const Wrapper = styled.span(
  ({ theme: { admanColors } }) => css`
    color: ${admanColors!.blue.solid};
    font-size: 14px;
    font-weight: 500;

    a {
      color: inherit;
      text-decoration: none;
    }
  `
);
